"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainAd = mapToDomainAd;
exports.mapToDomainAdDetail = mapToDomainAdDetail;
const AdMediaType_1 = require("../../enums/AdMediaType");
function mapToAdMediaType(mediaType) {
    return mediaType?.toUpperCase() === AdMediaType_1.AdMediaType.Video
        ? AdMediaType_1.AdMediaType.Video
        : AdMediaType_1.AdMediaType.Image;
}
function mapToDomainAd(dto) {
    return {
        id: dto.id,
        title: dto.title,
        mediaType: mapToAdMediaType(dto.mediaType),
        mediaUrl: dto.mediaUrl,
        duration: dto.duration ?? 0,
        createdAt: dto.createdAt,
        placementsCount: dto.placementsCount ?? 0,
    };
}
function mapToDomainAdDetail(dto) {
    return {
        id: dto.id,
        title: dto.title,
        mediaType: mapToAdMediaType(dto.mediaType),
        mediaUrl: dto.mediaUrl,
        duration: dto.duration ?? 0,
        createdAt: dto.createdAt,
        machineIds: dto.machineIds ?? [],
    };
}
